import { SxProps, Theme, styled } from '@mui/material/styles';
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
  Typography,
} from '@mui/material';
import { useField } from 'formik';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import theme from '../../themes';


export const BootstrapSelect = styled(Select)(({ theme }) => ({
  // '&.MuiInputBase-root': {
  //   '& .MuiSelect-select': {
  //     // color: '#8692A6',
  //     border: '1px solid #DDEAF3',
  //     fontSize: 16,
  //     padding: '10px 12px',
  //     borderRadius: 4,
  //     // transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
  //     // '&:focus': {
  //     //   boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
  //     //   borderColor: theme.palette.primary.main,
  //     // },
  //   },
  // },
  // '.MuiOutlinedInput-notchedOutline': {
  //   borderWidth: '1px',
  //   borderStyle: 'solid',
  //   borderColor: '#DDEAF3',
  // },
  // '&.Mui-focused,&:hover': {
  //   '.MuiOutlinedInput-notchedOutline': {
  //     borderWidth: '1px',
  //     borderColor: theme.palette.primary.main,
  //   },
  // },
  // svg: {
  //   color: '#337FC9',
  // },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: "10px",
    backgroundColor: `${theme.palette.common.white}OD`,
    border: `0.5px solid ${theme.palette.text.secondary}80 !important`,
  },
  "& .MuiSelect-select": {
    padding: "15px",
    "& span": {
      ...theme.typography.body_500,
      color: theme.palette.text.primary
    }
  },
  svg: {
    color: theme.palette.text.primary,
  },
}));

export default function MFSelectField({
  name,
  label,
  items,
  onChange,
  disabled = false,
  indexing = false,
  applyLabelStyles = false,
  isCapitalize = false,
  dropdownOptionStyle = {},
  ...rest
}: SelectProps & {
  name: string;
  label?: string;
  items: { key: string | number; value: string | number }[];
  onChange?: (event: SelectChangeEvent<unknown>) => void;
  disabled?: boolean;
  indexing?: boolean;
  applyLabelStyles?: boolean;
  isCapitalize?: boolean;
  dropdownOptionStyle?: SxProps<Theme>;
}): JSX.Element {
  const id = `${name}-input`;
  const labelId = `${id}-label`;

  const [field, meta] = useField(name);
  onChange = onChange || field.onChange;
  const errorText = meta.error && meta.touched ? meta.error : '';
  const errorId = `${id}-error`;
  return (
    <FormControl fullWidth sx={{ my: { xs: 1, sm: 1, md: 2 } }} error={!!errorText}>
      {label && (
        <InputLabel
          // shrink
          htmlFor={labelId}
          id={labelId}
          sx={(theme: Theme) => ({
            // transform: 'unset',
            // fontSize: 14,
            // fontWeight: 500,
            // color: 'rgba(0,0,0,0.7)',
            whiteSpace: applyLabelStyles ? 'normal' : 'nowrap',
            // position: applyLabelStyles ? 'relative' : 'absolute',
            color: disabled ? `${theme.palette.text.secondary}4D` : theme.palette.text.secondary,
            ...theme.typography.body_500,
          })}
        >
          {label?.split('*')[0]}
          {label?.includes('*') && (
            <Box component="span" sx={{ color: disabled ? `${theme.palette.text.secondary}4D` : theme.palette.error[500] }}> *</Box>
          )}
        </InputLabel>
      )}
      <BootstrapSelect
        labelId={labelId}
        label={label}
        id={id}
        inputProps={{
          'aria-label': label || name,
          'aria-invalid': !!errorText || undefined,
          'aria-describedby': errorText ? errorId : undefined,
          'aria-required': label?.includes('*') ? true : undefined,
        }}
        sx={{
          // mt: applyLabelStyles ? '10px' : '32px',
          ...rest.sx,
          '& .Mui-disabled': {
            cursor: !disabled ? 'pointer' : 'not-allowed !important',
            pointerEvents: 'all',
          },
        }}
        MenuProps={{
          sx: {
            '.MuiPaper-root ': {
              maxWidth: { xs: '100%', sm: '31%', md: '26%' },
              maxHeight: '20%',
              overflowX: 'auto',
            },
          },
        }}
        placeholder="ssss"
        IconComponent={ExpandMoreIcon}
        {...field}
        {...rest}
        onChange={onChange}
        disabled={disabled}>
        {items?.map((item, index: number) => (
          <MenuItem
            key={`${item.key}-${index}`}
            value={item.value}
            sx={(theme: Theme) => ({
              // fontSize: 14,
              // fontWeight: 500,
              ...theme.typography.body_500,
              color: theme.palette.text.primary,
              // '&.Mui-selected,&.Mui-selected:hover': { backgroundColor: 'unset' },
              '&.Mui-selected': { backgroundColor: 'action.selected' },
            })}>
            {indexing ? (
              <>
                <Typography
                  variant='body_500'
                  sx={{
                    color: 'text.primary',
                    // fontWeight: 500, 
                    // fontSize: 14 
                  }}
                  component="span">
                  C{index < 9 ? '0' + (index + 1) : index + 1}
                </Typography>
                <Typography
                  variant='body_500'
                  sx={{
                    // fontSize: 14,
                    // fontWeight: 500,
                    ...(isCapitalize ? { textTransform: 'capitalize' } : {}),
                    color: 'text.primary',
                    '&.Mui-selected,&.Mui-selected:hover': { backgroundColor: 'unset' },
                    ...dropdownOptionStyle
                  }}
                  component="span">
                  {isCapitalize ?
                    (typeof item?.key === "string" ? item?.key?.toLowerCase() : item?.key)
                    : item?.key}
                  {/* {item.key} */}
                </Typography>
              </>
            ) : (
              <Typography
                sx={{
                  whiteSpace: { xs: 'pre-wrap', sm: 'nowrap' },
                  ...(isCapitalize ? { textTransform: 'capitalize' } : {}),
                  ...dropdownOptionStyle
                }}
                component="span"
              >
                {/* {item.key} */}
                {isCapitalize ?
                  (typeof item?.key === "string" ? item?.key?.toLowerCase() : item?.key)
                  : item?.key}
              </Typography>
            )}
          </MenuItem>
        ))}
      </BootstrapSelect>
      {errorText && (
        <FormHelperText error sx={{ marginLeft: 'unset' }} id={errorId} role="alert" aria-live="polite">
          {errorText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
